const PUBLIC = `${process.env.PUBLIC_URL}`;

export const Images = {
  logoBrand: `${PUBLIC}/images/mtb-logo.png`,
};
